import { render, staticRenderFns } from "./CreateInvoiceForm.vue?vue&type=template&id=8cd13c06"
import script from "./CreateInvoiceForm.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports